import React from "react";
import "./ProductSpread.css";
import Item from "../Item/Item";

const ProductSpread = ({ title, products }) => {
  return (
    <div className="productspread">
      <h1>{title}</h1>
      <div className="productspread-item">
        {products.map((item) => {
          return (
            <Item
              key={item.id}
              id={item.id}
              name={item.name}
              image={item.image}
              price={item.price}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProductSpread;
